e.I = e.Insights = {
	init : function(){
	    //chart has it's own init at bottom via google

		e.I.year_select.init();
	}
};